import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppConfiguration, useAuthContext } from "./common";
import { PrivateRoute, PrivateRouteProps } from "./components";
import {
  Developer, DeveloperPageRoutes, PublicPages, PublicPagesRoutes, PublicPagesWebRoutes, Mail, Drive, Settings, Admin, Chat,
  SystemPrivatePages
} from "./pages";

function Router(): React.ReactElement {
  const auth_context = useAuthContext();
  const private_route_props: PrivateRouteProps = { ...auth_context };

  return <Routes>
    {/* Public Pages */}
    <Route path="/" element={<PublicPages />} >
      {AppConfiguration.buildForWeb() ? PublicPagesWebRoutes() : PublicPagesRoutes()}
    </Route>

    {/* DEV PAGES */}
    <Route path="developer" element={<Developer />} >
      {DeveloperPageRoutes()}
    </Route>

    {/* Mail Private Pages */}
    <Route path="mail/*" element={
      <PrivateRoute {...private_route_props} >
        <Mail />
      </PrivateRoute>
    } />

    {/* Drive Private Pages */}
    <Route path="drive/*" element={
      <PrivateRoute {...private_route_props} >
        <Drive />
      </PrivateRoute>
    } />

    {/* Drive Private Pages */}
    <Route path="chat/*" element={
      <PrivateRoute {...private_route_props} >
        <Chat />
      </PrivateRoute>
    } />

    {/* Settings Private Pages */}
    <Route path="settings/*" element={
      <PrivateRoute  {...private_route_props} >
        <Settings />
      </PrivateRoute>
    } />

    {/* Admin Private Pages */}
    <Route path="admin/*" element={
      <PrivateRoute  {...private_route_props} >
        <Admin />
      </PrivateRoute>
    } />

    {/* Remaining System PrivatePages for Create Organization and misc error pages  */}
    <Route path="*" element={
      <PrivateRoute {...private_route_props} >
        <SystemPrivatePages />
      </PrivateRoute>} />
  </Routes>;

}

export default Router;